import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { axiosClient } from '../../../core/axios-client'

const fetchClientHubs = createAsyncThunk(
    'client_hubs/fetchClientHubs',
    async ({ filters = {} } = {}) => {
        const response = await axiosClient.get('/client-hubs/', {
            params: { ...filters }
        })
        return response.data // ожидаем { count, results } как у /bikes/
    }
)

const fetchClientHub = createAsyncThunk(
    'client_hubs/fetchClientHub',
    async ({ id }) => {
        const response = await axiosClient.get(`/client-hubs/${id}`)
        return response.data
    }
)

const updateClientHub = createAsyncThunk(
    'client_hubs/updateClientHub',
    // Отправляем всё, что пришло из формы: раньше поля перечислялись вручную,
    // и услуги с фото до бэкенда не доходили - сохранялись только остальные.
    // rejectWithValue обязателен: без него unwrap() бросает служебный объект
    // RTK (name/message/stack), настоящий ответ бэкенда теряется, и вместо
    // «на точке ещё лежит товар» человек видит «AxiosError 400»
    async ({ id, ...data }, { rejectWithValue }) => {
        try {
            const response = await axiosClient.put(`/client-hubs/${id}`, data)
            return response.data
        } catch (error) {
            return rejectWithValue(error.response?.data ?? error.message)
        }
    }
)

const deleteClientHub = createAsyncThunk(
    'client_hubs/deleteClientHub',
    async ({ id }) => {
        const response = await axiosClient.delete(`/client-hubs/${id}`)
        return response.data
    }
)

const initialState = {
    listItems: {
        items: [],
        page: 1,
        page_size: 10,
        count: 0
    },
    client_hubs: [],
    client_hub: null,
}

export const slice = createSlice({
    name: 'client_hubs',
    initialState,
    reducers: {
        setListItems(state, { payload }) {
            state.listItems = {
                ...state.listItems,
                ...payload
            }
        },
        resetListItems(state) {
            state.listItems = { items: [], page: 1, page_size: 10, count: 0 }
        }
    },
    extraReducers: (builder) => {
        builder.addCase(fetchClientHubs.fulfilled, (state, { payload }) => {
            const { count = 0, results = [] } = payload || {}
            state.listItems = {
                ...state.listItems,
                items: results,
                count
            }
            state.client_hubs = results
        })

        builder.addCase(fetchClientHub.fulfilled, (state, { payload }) => {
            state.client_hub = payload
        })

        builder.addCase(updateClientHub.fulfilled, (state, { payload }) => {
            state.client_hub = payload
        })

        builder.addCase(deleteClientHub.fulfilled, (state /*, { payload } */) => {
            state.client_hub = null
        })
    }
})

export const { setListItems, resetListItems } = slice.actions

export {
    fetchClientHubs,
    fetchClientHub,
    updateClientHub,
    deleteClientHub,
    setListItems as setClientHubsListItems // optional alias if you used that name elsewhere
}

export default slice.reducer
